/** Calendar dates in the studio's India time zone; both range boundaries are inclusive. */
export function projectDate(value: string | Date): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
  const part = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  return part('year') + '-' + part('month') + '-' + part('day');
}
export function filterProjects<T extends { title: string; createdAt?: string; updatedAt: string }>(projects: T[], search: string, from: string, to: string): T[] {
  if (from && to && from > to) return [];
  const query = search.trim().toLocaleLowerCase();
  return projects.filter((p) => {
    const date = projectDate(p.createdAt || p.updatedAt);
    return p.title.toLocaleLowerCase().includes(query) && (!from || date >= from) && (!to || (!!date && date <= to));
  }).sort((a, b) => new Date(b.createdAt || b.updatedAt).getTime() - new Date(a.createdAt || a.updatedAt).getTime());
}
